'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";
export function IconLyrics(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M13.426 2.574a2.831 2.831 0 0 0-4.797 1.55l3.247 3.247a2.831 2.831 0 0 0 1.55-4.797zM10.5 8.118l-2.619-2.62A63303.13 63303.13 0 0 0 4.74 9.075L2.065 12.12a1.287 1.287 0 0 0 1.816 1.816l3.06-2.688 3.56-3.129zM7.12 4.094a4.331 4.331 0 1 1 4.786 4.786l-3.974 3.493-3.06 2.689a2.787 2.787 0 0 1-3.933-3.933l2.676-3.045 3.505-3.99z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M19.61 4.391a4 4 0 0 0-6.782 2.214l4.568 4.568a4 4 0 0 0 2.214-6.781zm-4.048 7.776-3.728-3.728-4.419 5.029-3.736 4.251a1.844 1.844 0 0 0 2.602 2.602l4.271-3.753 5.01-4.401zm-4.745-5.6a6 6 0 1 1 6.617 6.617l-5.562 4.887-4.27 3.753a3.844 3.844 0 0 1-5.425-5.425l3.749-4.266 4.89-5.566z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconLyrics is deprecated and will be archived soon. Use IconLyrics instead.
 */
export function Experimental__IconLyrics(props) {
  return /*#__PURE__*/React.createElement(IconLyrics, props);
}